import React from 'react';
import './PageHeader.css';

/**
 * Componente PageHeader
 * Header reutilizable para todas las páginas con diseño moderno
 */
const PageHeader = ({ title, subtitle, className = '' }) => {
    return (
        <section className={`page-header ${className}`}>
            <div className="container">
                <div className="page-header__content">
                    <h1 className="page-header__title animate-fade-in">{title}</h1>
                    {subtitle && (
                        <p className="page-header__subtitle animate-slide-up">{subtitle}</p>
                    )}
                </div>
            </div>
            <div className="page-header__decoration">
                <div className="page-header__circle page-header__circle--1"></div>
                <div className="page-header__circle page-header__circle--2"></div>
            </div>
        </section>
    );
};

export default PageHeader;
